import { apiClient } from "@/services/api-client";

export const postContactUsApi = (data) => {
  return apiClient({
    method: "POST",
    url: "/v1/contact",
    data,
  });
};
